import React from 'react'
import './Privacy.css'

const Thank = () => {
    return (
        <div className='bg-black myBg2 min-h-screen flex flex-col justify-center items-center text-white text-center px-6 md:px-20'>
            <p className='text-3xl sm:text-4xl md:text-7xl font-bold'>Thank you for</p>
            <p className='text-3xl sm:text-4xl md:text-7xl font-bold mt-2'>Booking a call with us.</p>
            
            <a target="_blank" rel="noopener noreferrer" href='https://chat.whatsapp.com/E2Rq5LB7zLz1qNc0J4OYzk'>
                <button className='px-6 py-3 sm:px-8 sm:py-4 text-black rounded-xl bg-gradient-to-l from-gold2 to-gold1 text-lg sm:text-xl mt-6 sm:mt-8'>Join Whatsapp Community</button>
            </a>
        </div>
    )
}

export default Thank
